<template>
  <div class="single-article">
    <single-article :articleId="$route.params.id">
      <template slot-scope="props">
        <article class="article main-article" v-if="props.article">
          <header>
            <article-tags :tags="['itrsoftware_oid']" :article="props.article" :showTags="false" @onTagsLoaded="onTagsLoaded"></article-tags>
            <h1>{{ props.article.title }}</h1>
            <ul class="details">
              <li>{{ props.article.date }}</li>
              <li v-for="(tag, index) in tags">
                <router-link :to="{ name: 'ArticlesForCategory', params: { categoryValue: props.article.itrsoftware_oid } }">
                  {{ tag.name }}
                </router-link>
              </li>
            </ul>
          </header>
          <div class="main">
            <div v-html="props.article.body_html"></div>
          </div>
        <div class="sharing">
          <div class="title"><i class="ion-android-share-alt"></i> Partage</div>
          <ul class="social">
            <li>
              <a href="https://www.facebook.com/sharer/sharer.php" class="facebook" target="_blank">
                <i class="ion-social-facebook"></i> Facebook
              </a>
            </li>
            <li>
              <a :href="`https://twitter.com/home?status=${pageUrl}`" class="twitter" target="_blank">
                <i class="ion-social-twitter"></i> Twitter
              </a>
            </li>
            <li>
              <a :href="`https://plus.google.com/share?url=${pageUrl}`" class="googleplus" target="_blank">
                <i class="ion-social-googleplus"></i> Google+
              </a>
            </li>
            <li>
              <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" class="linkedin" target="_blank">
                <i class="ion-social-linkedin"></i> Linkedin
              </a>
            </li>
          </ul>
        </div>
        <mail-transfer :id="$route.params.id"/>
        <h4>Sujets similaires</h4>
        <div class="similarArticles">
            <ul>
            <li v-for="(similarArticle, index) in props.article.similarArticles">
                <a :href="`https://${similarArticle.hostname}/articles/${similarArticle.oid}/${similarArticle.slug}`" target="_blank">{{ similarArticle.title }}</a><br/>
            </li>
            </ul>
        </div>
        </article>
      </template>
    </single-article>
    <h4>Commentaires</h4>
    <comments :id="$route.params.id"></comments>
  </div>
</template>


<script>
  import { SingleArticle, ArticleTags, Comments, MailTransfer } from 'itrnews-vuejs-api';

  export default {
    name: 'ArticlePage',
    components: { SingleArticle, ArticleTags, Comments, MailTransfer },
    methods: {
      onTagsLoaded(tags) {
        this.tags = tags;
      },
    },
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        tags: [],
        pageUrl: '',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ArticlePage.vue